import React, { useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { Icon_Menu } from '@Elements/ImageElements/Icons';

export default function Sidebar_Toggle(): JSX.Element {
    const [t] = useTranslation();
    const { set_sidebar_visible }: context_type = useContext(Context);

    return(
        <button
            type="button"
            className="Sidebar_Toggle"
            onClick={() => set_sidebar_visible(true)}
            aria-label={t('Aria.OpenSidebar')}
        >
            <Icon_Menu />
        </button>
    )
}